import {
    SET_IS_MUTE
} from '../constants/actions';

// [UPDATE] Shutdown Ack
const initialState = {
    isMute : true
};

// TODO : case문으로 변경하기...
const soundReducer = (state = initialState, action) => {
    if (action.type === SET_IS_MUTE) {
        return {...state, isMute: action.isMute};
    } else {
        return state; // reducer의 default는 state 반환
    }
};

export default soundReducer;